<template>
    <div class="stateLabel" :class="[{ portrait: ['portrait'].includes($mq) }, selectedState.id == id ? 'selected' : '', completed ? 'completed' : '', customClass, toPrintSelected ? 'checked' : '', { 'no-images': !showProductImage }]" @click="changeSelectedState()" :key="completed">
        <div v-if="showProductImage" class="image" :style="image != false ? { backgroundImage: 'url(' + image + ')' } : {}"></div>

        <div class="text">
            <div class="name">{{ formatDisplayMeasurement(name) }}</div>
            <div class="status" v-if="!['portrait'].includes($mq)"># {{ state.toUpperCase() }}</div>
            <div class="status" v-else>{{ state.toUpperCase() }}</div>
            <div class="package" v-if="package">{{ formatDisplayMeasurement(package) }}</div>
        </div>

        <div class="information">
            <div v-if="completed || !package" class="status" :class="{ completed: completed }">
                <i class="i-andy-exclamation i-andy-m"></i> <!-- Se quita por estilos -->
            </div>
            <!-- <div v-else-if="package" class="package">
                {{ package }}
            </div> -->
            <div class="quantity">x{{ currentQuantity ? currentQuantity : quantity }}</div>
        </div>
    </div>
</template>

<script>
import { formatMeasurementLabel } from '@/utils/numberFormat'

export default {
    name: 'StateLabel',
    props: ['id','stateID', 'collectionID', 'referenceID', 'name', 'state', 'image', 'quantity', 'selectedState', 'customClass', 'toPrintSelected', 'stateData', 'showImages'],
    data() {
        return {}
    },
    computed: {
        /**
         * BUILD-7687: undefined/true mantiene la foto (etiquetas y default).
         */
        showProductImage() {
            return this.showImages !== false
        },
        completed() {
            let collections = this.$store.getters['label/getCollections']
            return collections[this.collectionID].references[this.referenceID].states[this.stateID].completed
        },

        currentQuantity() {
            let collections = this.$store.getters['label/getCollections']
            let collection = collections[this.collectionID].references[this.referenceID].states[this.stateID]
            return typeof collection.currentQuantity !== 'undefined' ? collection.currentQuantity : false
        },

        package() {
            if (!this.stateData) return false
            let packageData = this.stateData.package
            return typeof packageData !== 'undefined' ? packageData : false
        }
    },
    created() {},
    methods: {
        formatDisplayMeasurement(value) {
            return formatMeasurementLabel(value, this.$i18n.locale, count => this.$tc('measurements.unit', count))
        },
        changeSelectedState() {
            if (!this.completed) {
                this.$emit('changeSelectedState', {
                    id: this.id,
                    stateID: this.stateID,
                    collectionID: this.collectionID,
                    referenceID: this.referenceID
                })
            }
        }
    }
}
</script>

<style lang="scss">
.stateLabel {
    @include interaction();
    @include display-flex();
    @include border-radius(5px);
    @include align-items();
    min-height: 40px;
    height: auto;
    padding: 6px;
    background-color: #fff;
    margin: 12px auto;

    @include bgHover(#fff);

    &:nth-child(1) {
        margin-top: 0;
    }

    &.selected {
        @include box-shadow($h: 0px, $v: 0px, $b: 0px, $s: 6px, $c: rgba(shade($default-bg-color, 6%), 1));

        .text .name {
            color: $main-s10;
        }
    }

    &.completed {
        cursor: initial;
        opacity: 0.6;
    }

    &.print-all-mode {
        background-color: $color-white;
        padding-left: 30px;
        border: 1px solid transparent;
        width: 100%;
        margin: 4px auto;
        &.selected {
            
            box-shadow: none;
        }
        &.checked {
            background-color: $main-t90;
            box-shadow: none;
            border: 1px solid $main-s10;
        }

        &.can-not-print {
            /* background-color: $error-t90 !important; */
            border: 2px solid $error !important;

            .information {
                @include display-flex();
                @include align-items(center);
                @include justify-content(center);
                
                .status {
                    @include display-flex();
                    @include justify-content(center);
                    
                    i{
                        display: block;
                        color: $error;
                    }
                }
            }

            &.portrait {
                .information {
                    gap:8px;
                }
            }
        }

        //PORTRAIT
        &.portrait {
            &.selected {
                box-shadow: none;
                background-color: $color-white;

                .text {
                    .name {
                        color: $main-s10;
                    }
                    .status {
                        color: $main-s10;
                    }
                }
                .information {
                    .quantity {
                        color: $main-s10;
                    }
                }
            }
            &.checked {
                background-color: $main-t90;
                box-shadow: none;
                border: 1px solid $main-s10;
            }
        }
    }

    &.checked {
        background-color: #eaf1ff !important;
        border: 2px solid #2A4377 !important;
        box-shadow: none !important;
    }

    .image {
        @include background($image: img('offline/no_icon_light.svg'), $size: 40px, $position: center center);
        width: 50px;
        height: 50px;
        display: inline-block;
    }

    &.no-images {
        .text {
            width: calc(100% - 30px);
        }
    }

    .text {
        @include display-inline-flex();
        flex-wrap: wrap;
        min-height: 24px;
        width: calc(100% - 50px - 30px);
        .name {
            @include font-size(m);
            font-family: $text-bold;
            width: 100%;
        }
        .status, .package {
            @include font-size(sm);
            width: 100%;
        }
    }

    .information {
        @include display-inline-flex();
        @include flex-direction(column);
        @include flex-wrap(wrap);
        min-width: 20px;
        width: 30px;
        height: 100%;
        .status {
            width: 100%;
            height: 20px;
            &.completed {
                @include background($image: img('printing_main_s10.svg'), $size: 20px, $position: center center);
            }

            i{
                display: none;
            }
        }
        .quantity {
            @include font-size(m);
            width: 100%;
            height: 20px;
            text-align: center !important;
            font-family: $conden-bold;
        }
    }
}
</style>

<style lang="scss">
.stateLabel {
    &.portrait {
        width: 100%;
        &.selected {
            background-color: $main;
            box-shadow: none;

            .text {
                .name {
                    color: #fff;
                }
                .status {
                    @include font-size(s);
                    font-family: $text;
                    color: #fff;
                }
            }
            .information {
                .quantity {
                    font-family: $text;
                    color: #fff;
                }
            }
        }
        .text {
            .name {
                @include text-ellipsis();
                max-width: 97%;
            }
            .status {
                @include font-size(xs);
                @include text-ellipsis();
                max-width: 97%;
            }
        }
    }
}
</style>
